import { NavLink, useParams } from 'react-router-dom';
import { dashboardSections } from '@/app/dashboard/navigation';
import { accentBarClass, accentTextClass } from '@/app/dashboard/accent';
import { Logo } from '@/components/layout/Logo';

/**
 * Full-height sidebar, visible md+ (768px). Below that, MobileNav takes over.
 * docs/DESIGN_SYSTEM.md §4.11 / §5.
 */
export function Sidebar() {
  const { guildId } = useParams<{ guildId: string }>();

  return (
    <aside className="hidden md:flex md:w-56 md:flex-col md:shrink-0 bg-bg-surface border-r border-border-subtle h-full">
      <div className="h-14 flex items-center px-4 border-b border-border-subtle">
        <Logo />
      </div>
      <nav className="flex-1 overflow-y-auto py-2" aria-label="Dashboard sections">
        {dashboardSections.map((section) => {
          const to = `/dashboard/${guildId}${section.path ? `/${section.path}` : ''}`;
          return (
            <NavLink
              key={section.path}
              to={to}
              end={section.path === ''}
              className={({ isActive }) =>
                [
                  'flex items-center gap-2.5 mx-2 px-2.5 py-2 rounded-sm text-body-medium border-l-2 transition-colors',
                  isActive
                    ? `bg-bg-elevated ${accentBarClass[section.accent]} ${accentTextClass[section.accent]}`
                    : 'border-transparent text-text-secondary hover:bg-bg-elevated hover:text-text-primary',
                ].join(' ')
              }
            >
              <section.icon size={18} aria-hidden="true" />
              {section.label}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
